import {MarkerClusterer} from "@googlemaps/markerclusterer";

// Removes linting error 'google is not defined'
/* global google */

export class RetailerMap {
  /** @type {number} */ addressZoom;

  /** @type {HTMLElement} */ mapElement;
  /** @type {HTMLInputElement} */ addressAutocompleteElement;
  /** @type {HTMLInputElement} */ b2bCheckboxElement;
  /** @type {HTMLInputElement} */ b2cCheckboxElement;

  /** @type {RetailerModel[]} */ retailerModels;
  /** @type {google.maps.Map} */ retailerMap;
  /** @type {google.maps.Marker[]} */ markersB2B = [];
  /** @type {google.maps.Marker[]} */ markersB2C = [];
  /** @type {google.maps.Marker[]} */ markersBoth = [];
  /** @type {MarkerClusterer} */ markerCluster;
  /** @type {google.maps.InfoWindow} */ infoWindow;
  /** @type {google.maps.places.Autocomplete} */ autocomplete;

  /**
   * @param {RetailerModel[]} retailerModels
   * @param {HTMLElement} mapElement
   * @param {HTMLInputElement} addressAutocompleteElement
   * @param {HTMLInputElement} b2bCheckboxElement
   * @param {HTMLInputElement} b2cCheckboxElement
   * @param {number} addressZoom
   */
  constructor(retailerModels, mapElement, addressAutocompleteElement, b2bCheckboxElement, b2cCheckboxElement, addressZoom,) {
    this.retailerModels = retailerModels;
    this.mapElement = mapElement;
    this.addressAutocompleteElement = addressAutocompleteElement;
    this.b2bCheckboxElement = b2bCheckboxElement;
    this.b2cCheckboxElement = b2cCheckboxElement;
    this.addressZoom = addressZoom;

    this._initRetailerMap();
    this._initSearchForm();
    this.infoWindow = new google.maps.InfoWindow();
  }

  _initSearchForm() {
    // Checkboxes
    this.b2bCheckboxElement.addEventListener('change', () => this._onCheckboxChanged());
    this.b2cCheckboxElement.addEventListener('change', () => this._onCheckboxChanged());

    // Autocomplete
    this.autocomplete = new google.maps.places.Autocomplete(this.addressAutocompleteElement, {
      fields: ['geometry'],
    });
    this.autocomplete.addListener('place_changed', () => this._onAddressSelected());
  }

  _onAddressSelected() {
    const place = this.autocomplete.getPlace();
    if (!place.geometry) {
      // User did not select a prediction; reset the input field
    } else {
      console.log(place);
      this.retailerMap.moveCamera({
        center: place.geometry.location, zoom: this.addressZoom,
      });
    }
  }

  _onCheckboxChanged() {
    const b2b = this.b2bCheckboxElement.checked;
    const b2c = this.b2cCheckboxElement.checked;
    const showAll = !b2b && !b2c;

    this.markerCluster.clearMarkers();
    this.markerCluster.addMarkers(this.markersBoth);
    if ((b2b && !b2c) || showAll) {
      this.markerCluster.addMarkers(this.markersB2B);
    }
    if ((!b2b && b2c) || showAll) {
      this.markerCluster.addMarkers(this.markersB2C);
    }
  }

  _initRetailerMap() {
    const boundsGermany = new google.maps.LatLngBounds(new google.maps.LatLng(47.2701115, 5.8663425), new google.maps.LatLng(55.0815, 15.0418962));

    this.retailerMap = new google.maps.Map(this.mapElement, {
      center: boundsGermany.getCenter(), mapTypeControl: false, streetViewControl: false, fullscreenControl: false, mapId: 'b74e23fa0fe42610'
    });

    this.retailerMap.fitBounds(boundsGermany);

    this._drawMarkers();

    this.retailerMap.addListener('click', () => {
      this.infoWindow.close();
    });
  }

  _drawMarkers() {
    this.retailerModels.forEach((retailer) => {
      let marker = new google.maps.Marker({
        // map: retailerMap,
        position: new google.maps.LatLng(retailer.latitude, retailer.longitude), // icon: "ICON.png",
      });

      marker.addListener('click', () => {
        this.infoWindow.setContent(this._createInfoWindowHtmlContent(retailer));
        this.infoWindow.open({
          map: this.retailerMap, anchor: marker,
        });
      });

      if (retailer.b2b && retailer.b2c) {
        this.markersBoth.push(marker);
      } else if (retailer.b2b) {
        this.markersB2B.push(marker);
      } else if (retailer.b2c) {
        this.markersB2C.push(marker);
      }
    });

    this.markerCluster = new MarkerClusterer({
      map: this.retailerMap,
      markers: [...this.markersBoth, ...this.markersB2B, ...this.markersB2C],
      renderer: new ClusterRenderer(),
    });
  }

  _createDirectionsLink(latitude, longitude) {
    return `https://www.google.com/maps/dir/?api=1&destination=${latitude},${longitude}`;
  }

  /**
   * @param {RetailerModel} retailer
   * @returns {string}
   * @private
   */
  _createInfoWindowHtmlContent(retailer) {
    let htmlContent = `<div class="map-infowindow">`;

    if (retailer.name) {
      htmlContent += `<div class="map-infowindow__title">${retailer.name}</div>`;
    }
    if (retailer.street) {
      htmlContent += `<div>${retailer.street}</div>`;
    }
    if (retailer.plz && retailer.city) {
      htmlContent += `<div>${retailer.plz} ${retailer.city}</div>`;
    } else if (retailer.plz) {
      htmlContent += `<div>${retailer.plz}</div>`;
    } else if (retailer.city) {
      htmlContent += `<div>${retailer.city}</div>`;
    }
    if (retailer.phone) {
      htmlContent += `<div class="map-infowindow__phone">Telefon: <a href="tel:${retailer.phone}">${retailer.phone}</a></div>`;
    }
    if (retailer.web) {
      htmlContent += `<div class="map-infowindow__web"><a href="${retailer.web}">Zur Website</a></div>`;
    }
    htmlContent += `<div><a target="_blank" href="${this._createDirectionsLink(retailer.latitude, retailer.longitude)}">Anfahrtsbeschreibung (Google Maps)</a></div></div>`;

    return htmlContent;
  }

}

class ClusterRenderer {
  render ({ count, position }) {
    const clusterIconSize = 34;
    const fontSize = count < 100 ? 16 : 12;

    // Create svg circle
    const svg = window.btoa(`
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100">
            <circle fill="white" cx="50" cy="50" opacity="0.5" r="50" />
            <circle fill="#E1523E" cx="50" cy="50" opacity="1" r="40" />
          </svg>`);

    // Create marker using svg icon
    return new google.maps.Marker({
      position,
      icon: {
        url: `data:image/svg+xml;base64,${svg}`,
        scaledSize: new google.maps.Size(clusterIconSize, clusterIconSize),
      },
      label: {
        text: String(count),
        color: "rgba(255,255,255,1)",
        fontSize: fontSize + "px",
        fontFamily: "Suisse Intl",
        fontWeight: "600"
      },

      // adjust zIndex to be above other markers
      zIndex: Number(google.maps.Marker.MAX_ZINDEX) + count,
    });
  }
};
